import { Link } from "react-router-dom";
import { StatusBadge, fmtDate } from "../../lib/status";

const SECTIONS = [
  { id: "current", label: "Current" },
  { id: "upcoming", label: "Upcoming" },
  { id: "completed", label: "Completed" },
  { id: "cancelled", label: "Cancelled" },
  { id: "no_show", label: "No show" },
];

export function CustomerBookingsTab({ bookings }) {
  const total = SECTIONS.reduce((n, s) => n + (bookings[s.id]?.length || 0), 0);
  if (total === 0) {
    return <div className="rounded-xl border border-slate-200 bg-white p-6 text-sm text-slate-500" data-testid="cp-bookings-empty">No bookings for this customer yet.</div>;
  }
  return (
    <div className="space-y-4" data-testid="cp-bookings">
      {SECTIONS.map((s) => {
        const items = bookings[s.id] || [];
        if (items.length === 0) return null;
        return (
          <div key={s.id} className="rounded-xl border border-slate-200 bg-white p-6" data-testid={`cp-bookings-${s.id}`}>
            <h3 className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-slate-500">
              {s.label} <span className="text-slate-400">({items.length})</span>
            </h3>
            <div className="mt-3 divide-y divide-slate-100">
              {items.map((b) => (
                <Link key={b.id} to={`/app/bookings/${b.id}`} data-testid={`cp-booking-${b.id}`}
                      className="block py-3 -mx-2 px-2 rounded-lg hover:bg-slate-50">
                  <div className="flex flex-wrap items-center justify-between gap-2">
                    <div>
                      <div className="font-medium">{b.vehicle?.name || "-"}</div>
                      <div className="text-xs text-slate-500 font-mono">{b.booking_reference}</div>
                    </div>
                    <StatusBadge status={b.status} isHold={b.is_hold} changeRequested={b.change_requested}
                                 cancelledBy={b.cancelled_by} cancellationReason={b.cancellation_reason}
                                 reconfirmationRequired={b.reconfirmation_required} />
                  </div>
                  <div className="text-sm text-slate-600 mt-1">{fmtDate(b.start_datetime)} → {fmtDate(b.end_datetime)}</div>
                </Link>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
